import { useState } from 'react';
import { useServices } from '../app-context';
import { ErrorBanner } from '../components/badges';
import { useAsync } from '../hooks/use-async';

const RANGES = [1, 7, 30, 90] as const;

export function PushStatsPage() {
  const { api } = useServices();
  const [days, setDays] = useState<number>(7);
  const stats = useAsync(() => api.pushStats(days), [api, days]);
  const rows = stats.data?.rows ?? [];
  const total = rows.reduce(
    (acc, r) => ({
      sent: acc.sent + r.sent,
      failed: acc.failed + r.failed,
      invalid: acc.invalid + r.invalid,
      rateLimited: acc.rateLimited + r.rateLimited,
    }),
    { sent: 0, failed: 0, invalid: 0, rateLimited: 0 },
  );

  return (
    <div>
      <h1>Push stats</h1>
      <label>
        Period
        <select value={days} onChange={(e) => setDays(Number(e.target.value))}>
          {RANGES.map((d) => (
            <option key={d} value={d}>
              {d === 1 ? 'Today' : `Last ${d} days`}
            </option>
          ))}
        </select>
      </label>
      <ErrorBanner message={stats.error} />
      {stats.data && (
        <table>
          <thead>
            <tr>
              <th>Tenant</th>
              <th>Sent</th>
              <th>Failed</th>
              <th>Invalid tokens</th>
              <th>Rate limited</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.tenantCode}>
                <td>{r.tenantCode}</td>
                <td>{r.sent}</td>
                <td>{r.failed}</td>
                <td>{r.invalid}</td>
                <td>{r.rateLimited}</td>
              </tr>
            ))}
          </tbody>
          <tfoot>
            <tr>
              <th>Total since {stats.data.since}</th>
              <th>{total.sent}</th>
              <th>{total.failed}</th>
              <th>{total.invalid}</th>
              <th>{total.rateLimited}</th>
            </tr>
          </tfoot>
        </table>
      )}
      {stats.data && rows.length === 0 && <p>No pushes in this period.</p>}
    </div>
  );
}
